"use client";

import type React from "react";

import { useAuth } from "@/lib/auth-context";
import { Header } from "./header";
import { AppSidebar } from "./app-sidebar";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (user) {
    // Logged in layout with sidebar and dark mode
    return (
      <div className="dark">
        <SidebarProvider defaultOpen={true}>
          <AppSidebar />
          <SidebarInset className="bg-gray-900 min-h-screen">
            <main className="flex-1">{children}</main>
          </SidebarInset>
        </SidebarProvider>
      </div>
    );
  }

  // Logged out layout with header and light mode
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>{children}</main>
    </div>
  );
}
